import React from 'react';

// Qykfin Logo Component - Multiple variants
const QykfinLogo = ({ variant = 'default', size = 'md', className = '' }) => {
  const sizes = {
    sm: { width: 100, height: 28, fontSize: 16, iconSize: 20 },
    md: { width: 120, height: 32, fontSize: 20, iconSize: 24 },
    lg: { width: 160, height: 44, fontSize: 28, iconSize: 32 }
  };

  const s = sizes[size];

  // Color variants
  const variants = {
    default: {
      primary: '#1D1D1F',
      accent: '#0071E3',
      gradient: 'url(#logoGradient)'
    },
    blue: {
      primary: '#0071E3',
      accent: '#5856D6',
      gradient: 'url(#logoGradientBlue)'
    },
    dark: {
      primary: '#FFFFFF',
      accent: '#0071E3',
      gradient: 'url(#logoGradientDark)'
    },
    gradient: {
      primary: 'url(#textGradient)',
      accent: '#0071E3',
      gradient: 'url(#logoGradient)'
    }
  };

  const v = variants[variant] || variants.default;

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {/* Icon Mark */}
      <svg 
        width={s.iconSize} 
        height={s.iconSize} 
        viewBox="0 0 32 32" 
        fill="none"
      >
        <defs>
          <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#0071E3" />
            <stop offset="100%" stopColor="#5856D6" />
          </linearGradient>
          <linearGradient id="logoGradientBlue" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#0071E3" />
            <stop offset="100%" stopColor="#00C7BE" />
          </linearGradient>
          <linearGradient id="logoGradientDark" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#5856D6" />
            <stop offset="100%" stopColor="#0071E3" />
          </linearGradient>
        </defs>
        
        {/* Abstract Q mark representing finance/speed */}
        <rect x="4" y="4" width="24" height="24" rx="6" fill={v.gradient} />
        <path 
          d="M12 10L20 16L12 22V10Z" 
          fill="white"
          opacity="0.9"
        />
        <circle cx="20" cy="22" r="4" fill="white" />
      </svg>

      {/* Wordmark */}
      <span 
        className="font-dm font-bold tracking-tight"
        style={{ 
          fontSize: s.fontSize,
          color: variant === 'gradient' ? 'transparent' : (variant === 'dark' ? '#FFFFFF' : '#1D1D1F'),
          background: variant === 'gradient' ? 'linear-gradient(135deg, #0071E3, #5856D6)' : 'none',
          WebkitBackgroundClip: variant === 'gradient' ? 'text' : 'unset',
          backgroundClip: variant === 'gradient' ? 'text' : 'unset'
        }}
      >
        Qykfin
      </span>
    </div>
  );
};

// Simple text logo for nav
export const QykfinLogoSimple = ({ dark = false, className = '' }) => (
  <div className={`flex items-center gap-2 ${className}`}>
    <div className="relative">
      <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-[#0071E3] to-[#5856D6] flex items-center justify-center">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M4 3L12 8L4 13V3Z" fill="white" opacity="0.95"/>
          <circle cx="12" cy="12" r="2.5" fill="white"/>
        </svg>
      </div>
    </div>
    <span className={`font-dm text-xl font-bold tracking-tight ${dark ? 'text-white' : 'text-[#1D1D1F]'}`}>
      Qykfin
    </span>
  </div>
);

// Icon only version
export const QykfinIcon = ({ size = 32, className = '' }) => (
  <div 
    className={`rounded-xl bg-gradient-to-br from-[#0071E3] to-[#5856D6] flex items-center justify-center ${className}`}
    style={{ width: size, height: size }}
  >
    <svg width={size * 0.5} height={size * 0.5} viewBox="0 0 16 16" fill="none">
      <path d="M4 3L12 8L4 13V3Z" fill="white" opacity="0.95"/>
      <circle cx="12" cy="12" r="2.5" fill="white"/>
    </svg>
  </div>
);

export default QykfinLogo;
